/**
 * Register the VibeCheck service worker after window load — keeps the
 * critical-rendering path clean and avoids competing for bandwidth on the
 * first paint.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Only register on http(s) — skip for dev file:// or insecure origins
  if (window.location.protocol !== "https:" && window.location.hostname !== "localhost") {
    // CRA dev server runs on http but we still want SW behaviour for
    // localhost so install prompts can be tested.
    if (window.location.hostname !== "localhost") return;
  }
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch((err) => {
        // Soft-fail — the app still works without a service worker.
        // eslint-disable-next-line no-console
        console.warn("[VibeCheck] SW registration failed:", err);
      });
  });
}
